import { useState } from "react";
import { useStore } from "@nanostores/react";
import styled from "styled-components";
import { useMakePayment } from "../../hooks/useMakePayment";
import { useBankPaymentTokenization } from "../../services/tokenization/useBankPaymentTokenization";
import { brandSettings, paymentInfo } from "../../store/nanostore";
import { CheckedBox, UncheckedCircle } from "./PaymentInfo.styled";
import { PayBtn1 } from "./UserInfo";

type ListUserBankAccountProps = {
  request: any;
  makePayment: any;
  bankInfo: any;
};
export const ListUserBankAccount: React.FC<ListUserBankAccountProps> = ({
  request,
  makePayment,
  bankInfo,
}) => {
  const $paymentInfo = useStore(paymentInfo);
  const [selectedAccount, setSelectedAccount] = useState<any>(null);
  const $brandSettings = useStore(brandSettings);

  const handleInitPayment = () => {
    makePayment({
      tokenId: selectedAccount,
      amount: $paymentInfo.productPrice,
      emailOrPhone: {
        email: $paymentInfo?.payload?.email,
        phoneNumber: $paymentInfo?.payload?.phone,
      },
    });
  };

  return bankInfo.status === "active" ? (
    <>
      {bankInfo?.tokens?.map((data: any, index: number) => (
        <AccountCard
          key={data.token || index} // Use a unique key, fallback to index if necessary
          onClick={() => setSelectedAccount(data.token)}
        >
          <div className="title-box">
            <i>
              {selectedAccount === data.token ? (
                <CheckedBox />
              ) : (
                <UncheckedCircle />
              )}
            </i>
            <strong>{data?.accountName}</strong>
          </div>
          <span>
            {"*".repeat(6)}
            {data?.last4}
          </span>
        </AccountCard>
      ))}
      <PayBtn1
        backgroundColor={$brandSettings?.primaryColor}
        color={$brandSettings?.secondaryColor}
        onClick={handleInitPayment}
        $active={selectedAccount && !request?.loading}
        css={`
          width: 100%;
        `}
      >
        {request?.loading ? "Saving" : "Next"}
      </PayBtn1>
    </>
  ) : (
    <h3>This user email/phone account is currently {bankInfo.status}</h3>
  );
};

const AccountCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 25px;
  border: 1px solid #aaa;
  border-radius: 8px;
  width: 300px;
  margin: 10px 0;

  cursor: pointer;
  .title-box {
    display: flex;
    gap: 10px;
  }
`;
